import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import TGButton from 'src/components/ui/TGButton';
import Loading from 'src/components/Loading';

type AlertArchiveProps = {
  isOpen: boolean;
  title: string;
  text: string;
  onClose: () => void;
  onCloseForm: () => void;
  offArchive?: boolean;
  isProcessing?: boolean;
};

function AlertArchive({ title, text, isOpen, onClose, onCloseForm, offArchive = false, isProcessing = false }: AlertArchiveProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} className='relative' style={{ zIndex: 60 }}>
      <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in' />

      <div className='fixed inset-0 z-30 w-screen overflow-y-auto'>
        <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
          <div className='relative transform rounded-lg max-w-2xl bg-white px-8 py-8 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95'>
            <button type='button' onClick={onClose} className='absolute right-[-28px] top-0 outline-none rounded-md text-white opacity-80 hover:opacity-100'>
              <span className='sr-only'>Close</span>
              <XMarkIcon aria-hidden='true' className='h-6 w-6' />
            </button>

            <div className='text-black'>
              <h1 className='text-2xl'>{title}</h1>

              <div className='mt-8'>
                <p className='text-base text-black'>{text}</p>
              </div>
            </div>

            <div className='flex justify-between mt-8 border-t pt-8'>
              <TGButton type='button' onClick={onClose} disabled={isProcessing}>
                Отмена
              </TGButton>

              <TGButton type='button' color='bluedark' onClick={onCloseForm} disabled={isProcessing}>
                {isProcessing ? (
                  <span className='flex items-center gap-2'>
                    <Loading />
                    {offArchive ? 'Разархивируется...' : 'Архивируется...'}
                  </span>
                ) : (
                  offArchive ? 'Разархивировать' : 'Архивировать'
                )}
              </TGButton>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default AlertArchive;
